import { defineComponent, ref, computed, onMounted, reactive } from "vue";
import { pauseVideoAudio } from "@com/utils/pause-video-audio";
import { AssetStatus } from "@pt/enums/assets";
import TranscodeLayer from "./transcode-layer.vue";
export default defineComponent({
    props: {
        width: {
            type: Number,
            default: 200
        },
        height: {
            type: Number,
            default: 200
        },
        src: {
            type: String,
            required: true
        },
        cover: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: "video"
        },
        poster: {
            type: String,
            default: "\u5C01\u9762\u56FE"
        },
        // 转码的状态
        status: {
            type: String,
            default: ""
        },
        // 转码中的进度
        progress: {
            type: Number
        },
        // 资源id
        id: {
            type: String
        },
        cors: {
            type: String
        }
    },
    components: {
        TranscodeLayer: TranscodeLayer
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var mediaStyle = reactive({
            width: props.width + "px",
            height: props.height + "px"
        });
        var showCover = ref(true);
        var videoPlayer = ref(null);
        var audioPlayer = ref(null);
        var playStatus = ref(false);
        var playIcon = computed(function() {
            return playStatus.value ? "pause" : "play";
        });
        var playVideo = function() {
            var player = props.type === "video" ? videoPlayer.value : audioPlayer.value;
            if (playStatus.value) {
                player.pause();
            } else {
                pauseVideoAudio();
                player.play();
            }
        };
        var addVideoEvent = function() {
            var _$ref, _$ref1, // 允许播放的时候隐藏封面图
            _$ref2;
            (_$ref = videoPlayer.value) === null || _$ref === void 0 ? void 0 : _$ref.addEventListener("play", function() {
                playStatus.value = true;
            });
            (_$ref1 = videoPlayer.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.addEventListener("pause", function() {
                playStatus.value = false;
            });
            (_$ref2 = videoPlayer.value) === null || _$ref2 === void 0 ? void 0 : _$ref2.addEventListener("loadeddata", function() {
                console.log("video onloadeddata");
                showCover.value = false;
            });
        };
        var addAudioEvent = function() {
            var _$ref, _$ref3;
            (_$ref = audioPlayer.value) === null || _$ref === void 0 ? void 0 : _$ref.addEventListener("play", function() {
                playStatus.value = true;
            });
            (_$ref3 = audioPlayer.value) === null || _$ref3 === void 0 ? void 0 : _$ref3.addEventListener("pause", function() {
                playStatus.value = false;
            });
        };
        // 转码失败重试
        var retryEvent = function(id) {
            emit("retry", id);
        };
        onMounted(function() {
            if (props.type === "video") {
                addVideoEvent();
            } else {
                addAudioEvent();
            }
        });
        return {
            showCover: showCover,
            mediaStyle: mediaStyle,
            videoPlayer: videoPlayer,
            audioPlayer: audioPlayer,
            playIcon: playIcon,
            playVideo: playVideo,
            AssetStatus: AssetStatus,
            retryEvent: retryEvent
        };
    }
});
